(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ogani-header"]) return;
  try {
    
  if (!customElements.get('yntex-navigation')) {
    customElements.define('yntex-navigation', class extends HTMLElement {
      connectedCallback() {
        this.listeners = [];
        const listen = (target, type, handler, options) => {
          if (!target) return;
          target.addEventListener(type, handler, options);
          this.listeners.push(() => target.removeEventListener(type, handler, options));
        };
        this.dialog = this.querySelector('dialog');
        const popups = [...this.querySelectorAll('[data-yn-popup]')];
        const categories = [...this.querySelectorAll('.yn-category')];
        const closePopups = (except) => popups.forEach(popup => { if (popup !== except) popup.open = false; });
        popups.forEach(popup => listen(popup, 'toggle', () => { if (popup.open) closePopups(popup); }));
        categories.forEach(category => {
          const summary = category.querySelector('summary');
          const activate = () => { categories.forEach(item => { item.open = item === category; }); };
          listen(summary, 'click', event => { event.preventDefault(); activate(); });
          listen(summary, 'pointerenter', event => { if (event.pointerType === 'mouse' && !this.querySelector('.yn-category-panel :focus')) activate(); });
        });
        this.restore = () => {
          document.body.classList.remove('yn-menu-open');
          this.backdrop?.remove();
          this.dialog?.classList.remove('yn-dialog-fallback');
          this.opener?.setAttribute('aria-expanded', 'false');
          if (this.opener?.isConnected) this.opener.focus();
        };
        this.closeMenu = () => {
          if (!this.dialog?.hasAttribute('open')) return;
          if (this.dialog.classList.contains('yn-dialog-fallback')) {
            this.dialog.removeAttribute('open'); this.restore();
          } else this.dialog.close();
        };
        listen(document, 'click', event => {
          const opener = event.target.closest?.('[data-yn-open]');
          if (opener && this.dialog) {
            if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
            closePopups(); this.opener = opener;
            if (!this.dialog.hasAttribute('open')) {
              try {
                if (typeof this.dialog.showModal !== 'function') throw new Error('Dialog unavailable');
                this.dialog.showModal();
              } catch {
                this.dialog.classList.add('yn-dialog-fallback');
                this.dialog.setAttribute('open', '');
                this.backdrop = document.createElement('div');
                this.backdrop.className = 'yn-dialog-backdrop';
                this.dialog.before(this.backdrop);
                this.backdrop.addEventListener('click', () => this.closeMenu());
              }
            }
            event.preventDefault();
            document.body.classList.add('yn-menu-open');
            opener.setAttribute('aria-expanded', 'true');
            this.dialog.querySelector('[data-yn-close]')?.focus();
          } else if (!this.contains(event.target)) closePopups();
        }, true);
        listen(this.querySelector('[data-yn-close]'), 'click', () => this.closeMenu());
        listen(this.dialog, 'click', event => {
          if (event.target === this.dialog) {
            const box = this.dialog.getBoundingClientRect();
            if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.closeMenu();
          }
        });
        listen(this.dialog, 'close', () => this.restore());
        listen(document, 'keydown', event => {
          if (this.dialog?.hasAttribute('open')) {
            if (event.key === 'Escape') { event.preventDefault(); this.closeMenu(); }
            if (event.key === 'Tab') {
              const items = [...this.dialog.querySelectorAll('a[href], button, summary, input, [tabindex="0"]')].filter(item => item.getClientRects().length && !item.disabled);
              const first = items[0], last = items[items.length - 1];
              if (event.shiftKey && (document.activeElement === first || !this.dialog.contains(document.activeElement))) { event.preventDefault(); last?.focus(); }
              else if (!event.shiftKey && (document.activeElement === last || !this.dialog.contains(document.activeElement))) { event.preventDefault(); first?.focus(); }
            }
            return;
          }
          if (event.key !== 'Escape') return;
          const active = popups.find(popup => popup.open && popup.contains(document.activeElement));
          closePopups(); active?.querySelector('summary')?.focus();
        });
        listen(this, 'focusout', () => setTimeout(() => {
          if (!this.contains(document.activeElement)) closePopups();
        }, 0));
      }
      disconnectedCallback() { this.closeMenu?.(); this.restore?.(); this.listeners?.forEach(remove => remove()); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yntex-bottom-nav"]) return;
  try {
    
  if (!customElements.get('yntex-bottom-nav')) customElements.define('yntex-bottom-nav', class extends HTMLElement {
    connectedCallback() {
      if (typeof ResizeObserver !== 'function') return;
      this.observer = new ResizeObserver(() => document.body.style.setProperty('--yn-dock-space', `calc(${this.offsetHeight + 28}px + env(safe-area-inset-bottom))`));
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); document.body.style.removeProperty('--yn-dock-space'); }
  });

  } catch(e) { console.error(e); }
})();
})();
